// extracted by mini-css-extract-plugin
export var textArea = "TextArea-module--textArea--NtYpd";